import React from "react";
import ColorPicker from "@_components/ColorPicker/ColorPicker";
import styles from "../SettlementPortalLinkPopup.module.css";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";

function ButtonComponent({
  text,
  FormHelperTextProps,
  onTextChange,
  bgColor,
  fgColor,
  onBgColorChange,
  onFgColorChange,
  error,
}) {
  return (
    <div className={styles.button_component_container}>
      <div className={styles.button_input_container}>
        <TextfieldInput
          label="Label"
          aria-label="Button Label Input"
          value={text}
          onChange={(e) => onTextChange(e.target.value)}
          error={error}
          helperText={error}
          FormHelperTextProps={FormHelperTextProps}
          required
        />
      </div>

      <div className={styles.color_picker_row}>
        <div className={styles.color_picker_block}>
          <span className={styles.color_label}>Button Color:</span>
          <ColorPicker
            color={bgColor}
            onChange={(color) => {
              onBgColorChange(color);
            }}
            aria-label="Background Color Picker"
          />
        </div>

        <div className={styles.color_picker_block}>
          <span className={styles.color_label}>Text Color:</span>
          <ColorPicker
            color={fgColor}
            onChange={(color) => {
              onFgColorChange(color);
            }}
            aria-label="Text Color Picker"
          />
        </div>
      </div>
    </div>
  );
}

export default ButtonComponent;
